import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

interface DeferredRedirectProps {
  to: {
    pathname: string
    search: string
    hash: string
  }
}

/**
 * Deferred redirect component that uses useEffect to avoid
 * synchronous suspense issues with lazy-loaded components.
 */
export const DeferredRedirect = ({ to }: DeferredRedirectProps) => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(to, { replace: true })
  }, [navigate, to])

  return null
}
